import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo'
import 'semantic-ui-css/semantic.min.css'
import 'react-table/react-table.css'

import './index.css'
import App from 'components/App'
import storeConfig from 'store/storeConfig'

const networkInterface = createNetworkInterface({
  uri: process.env.REACT_APP_API_URL,
})

const store = storeConfig()

networkInterface.use([{
  applyMiddleware (req, next) {
    if (!req.options.headers) {
      req.options.headers = {}
    }
    const auth = store.getState().auth
    req.options.headers.authorization = auth.userDetails.sub
    next()
  }
}])

const client = new ApolloClient({
  networkInterface,
})

ReactDOM.render(
  <ApolloProvider client={client} store={store}>
    <App store={store} />
  </ApolloProvider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js